import { GAUGE_DEFAULT_CONFIG } from '../constants.js';
import { applyThresholdDefaults } from './apply-threshold-default.js';
import type { GaugeChartInternalConfig } from '../types/gauge-chart-config-internal.js';
import type {
  GaugeChartConsumerConfig,
  GaugeChartSlotsConfig,
} from '../types/gauge-chart-config.js';
import type { GaugeChartProps } from '../types/gauge-chart.js';

export const buildGaugeChartConfig = (
  props: GaugeChartProps,
  consumerConfig: GaugeChartConsumerConfig,
  slots: GaugeChartSlotsConfig,
): GaugeChartInternalConfig => {
  const min = props.min ?? consumerConfig.min ?? GAUGE_DEFAULT_CONFIG.min;
  const max = props.max ?? consumerConfig.max ?? GAUGE_DEFAULT_CONFIG.max;
  const color =
    props.color ?? consumerConfig.color ?? GAUGE_DEFAULT_CONFIG.color;
  const formatter = props.formatter ?? consumerConfig.formatter;

  const thresholds =
    slots.thresholds.length === 0
      ? consumerConfig.thresholds?.map(applyThresholdDefaults)
      : slots.thresholds;

  return {
    min,
    max,
    color,
    formatter,
    thresholds,
    labelSlot: slots.label,
    valueLabelSlot: slots.valueLabel,
    minLabelSlot: slots.minLabel,
    maxLabelSlot: slots.maxLabel,
  };
};
